import React from 'react';
import Footer from '../../Components/Footers/Footer';
import Header from '../../Components/Headers/Header';
import Paper from '@mui/material/Paper';
import '../../assests/css/SightSeeing.css';
import seight_seeing from '../../assests/images/seightseeing.png';
import { Link } from 'react-router-dom';
import img1_scene from '../../assests/images/seightseeing.png';
import img2_scene from '../../assests/images/singlesight2.png';
import img3_scene from '../../assests/images/singlesight3.png';
import img4_scene from '../../assests/images/singlesight4.png';

const SightSeeing = () => {

    let arr = [
        { img: `${img1_scene}` }
        , { img: `${img2_scene}` }
        , { img: `${img3_scene}` }
        , { img: `${img4_scene}` }
    ];

    return (
        <div className='sightseeing'>
            <section className='bg-privacy-policy-top mb-3'>
                <Header />
                <div className='container '>
                    <div className='row px-3'>
                        <div className='col-lg-12 my-4 text-center'>
                            <p className='text-white f-72 my-5 f-pop-med'>Sight Seeing</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='mb-5'>
                <div className='container'>
                    <div className='row '>
                        <div className='col-lg-12 text-center'>
                            <p className='f-pop-med f-20 mt-5 clr-df mb-2'>Route Packages</p>
                            <p className='f-pop-med f-25 clr-04 mb-5'>Sight Seeing</p>
                        </div>
                        {arr.map((item, index) => {
                            return (

                                <div key={index} className='col-lg-12 mb-4'>
                                    <Link className='link_single_sight' to="/singlesight">
                                        <Paper elevation={2} className="py-5 ps-5 pe-1 res-ps-pe-sightseeing" >
                                            <div className='row'>
                                                <div className='col-lg-4 text-center'>
                                                    <div className='w-100'>
                                                        <img className='w-100' src={item.img} alt="seight seeing image" />
                                                    </div>
                                                </div>
                                                <div className='col-lg-6 align-self-center'>
                                                    <div className='box_seight_seeing res-ps-pe-sightseeing'>
                                                        <p className='f-22 f-pop-semibold clr-00 mb-3'>Lorem Ipsum <span className='ms-3 f-pop-semibold f-16'>$ 8.00</span></p>
                                                        <p className='clr-9f f-16  mt-2'>Curabitur placerat cursus nisi nec phare tra. Proin </p>
                                                        <ul className="ul_pad_zero  mt-4">
                                                            <li className="ul_tick_round f-pop-med clr-9f">
                                                                Lorem ipsum
                                                            </li>
                                                            <li className="ul_tick_round f-pop-med clr-9f">
                                                                Lorem ipsum
                                                            </li>
                                                            <li className="ul_tick_round f-pop-med clr-9f">
                                                                Lorem ipsum
                                                            </li>
                                                            <li className="ul_tick_round f-pop-med clr-9f">
                                                                Lorem ipsum
                                                            </li>
                                                            <li className="ul_tick_round f-pop-med clr-9f">
                                                                Lorem ipsum
                                                            </li>
                                                        </ul>
                                                        {/* <Link to="/booking" className='link_ourfleet'>
                                                            <button className='btn btn-danger bt-seeing f-16 f-pop-semibold mt-4'>Booking now </button>
                                                        </Link> */}

                                                    </div>
                                                </div>
                                                <div className='col-lg-2 text-center pos-rel'>
                                                    <div className='paper-rotate'>
                                                        <p className='f-14 f-pop-med clr-71'>Want to discuss contact us</p>
                                                        <p className='f-18 f-pop-med text-dark'>+441279-247-247</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Paper>
                                    </Link>
                                </div>

                            );
                        })}


                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default SightSeeing;